import { decode as base64_decode, encode as base64_encode } from 'base-64';
import { postApi,baseURL } from '../components/Utility'
import {
    action,
    computed,
    makeObservable,
    observable,
    autorun,
    runInAction,
} from 'mobx';
import { message } from "antd";
import config from "../config";

class TempReportStore {
    total=0
    tempReportStore = []
    rootStore
    loading=false

    constructor(rootStore) {
        makeObservable(this, {
            total:observable,
            tempReportStore: observable,
            loadData: action,
            loading:observable
        });
        this.rootStore = rootStore;
    }



    async loadData({companyId,vehicleId,offset,limit,fromDate,toDate,pageNo}) {

       this.loading=true
        var postData = { "companyId": companyId, "vehicleId": vehicleId, "temp1min": "", "temp1max": "", "temp2min": "", "temp2max": "", "temp3min": "", "temp3max": "", "intervel": 5, "fromDate": fromDate, "showFlag": 0, "toDate": toDate, "offset": offset, "limit": limit, "page": pageNo }
        if(config.clickhouseReportUrl === 1){
            var response = await postApi.getClient('report').post("/tracking_report/trackData", postData);
            this.tempReportStore = response?.data?.data?.completereport
        }else{
            const base64Input = await base64_encode(JSON.stringify(postData));
            var response = await postApi.getClient().post("index.php?c=vehicle&a=temprep", "postData=" + base64Input);
             this.tempReportStore = response?.data?.data?.temprep
        }
       
        this.total=parseInt(response?.data?.data?.TotalCount)
        this.loading=false

    }
 
    async exportExcel(getData) {

        if(config.clickhouseReportUrl === 1){ 

            try {
                // await postApi.getClient("report").post("http://localhost:5000/tracking_report/tempReport/download/excel", getData, {
                //     responseType: "blob",
                // });
                await postApi.getClient("report").post("/tracking_report/tempReport/download/excel", getData, {
                    responseType: "blob",
                });
                this.pythonReportMessage = true;
            } catch (error) {
                this.pythonReportErrorMessage = true;
            }
    
        }else{
            let lang = "english";
            window.location.href =
              baseURL +
              "index.php?c=vehicle&a=exporttempexcel&cid=" +
              getData.companyId +
              "&userId=" +
              getData.userId+
              "&vid=" +
              getData.vehicleId +
              "&int=" +
            5 +
              "&t1max" +
              " "+
              "&t1min" +
              " "+
              "&t2min" +
              " "+
              "&t2max" +
              " "+
              "&t3min" +
              " "+
              "&t3max" +
              " "+

              "&fD=" +
              getData.fromDate +
              "&tD=" +
              getData.toDate +
              "&colList=" +
              getData.colList +
              ",&language=" +
              lang;
        }
    }

    async exportpdf(getData) {

        if(config.clickhouseReportUrl === 1){   
            
            try {
                // await postApi.getClient("report").post("http://localhost:5000/tracking_report/tempReport/download/pdf", getData, {
                //     responseType: "blob",
                // });
                await postApi.getClient("report").post("/tracking_report/tempReport/download/pdf", getData, {
                    responseType: "blob",
                });

                this.pythonReportMessage = true;
            } catch (error) {
                this.pythonReportErrorMessage = true;
            }

        }else{
            let lang = "english";
            window.location.href =
                baseURL +
                "index.php?c=vehicle&a=exportcrTempPdf&cid=" +
                getData.companyId +
                "&userId=" +
                getData.userId+
                "&vid=" +
                getData.vehicleId +
                "&int=" +
            5 +
                "&t1max" +
                " "+
                "&t1min" +
                " "+
                "&t2min" +
                " "+
                "&t2max" +
                " "+
                "&t3min" +
                " "+
                "&t3max" +
                " "+

                "&fD=" +
                getData.fromDate +
                "&tD=" +
                getData.toDate +
                "&colList=" +
                getData.colList ;
        }
    }

    async sendEmailReport(getData) {
        try {
            // await postApi.getClient("report").post("http://localhost:5000/tracking_report/tempReport/download/email", getData, {
            //     responseType: "blob",
            // });
            await postApi.getClient("report").post("/tracking_report/tempReport/download/email", getData, {
                responseType: "blob",
            });

            this.pythonReportMessage = true;
        } catch (error) {
            this.pythonReportErrorMessage = true;
        }
    }
      

}

export default TempReportStore;
